import { Component, EventEmitter, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'hub-lo-revoke-step',
    styleUrls: ['./revoke-step.component.scss'],
    templateUrl: 'revoke-step.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class HubLoRevokeStepComponent {
    @Output() public confirm = new EventEmitter<void>();
    @Output() public closeDrawer = new EventEmitter<void>();
}
